// @flow
import { createSelector } from 'reselect';

const globalLoaderSelector = ({ globalLoader }) => globalLoader || {};

const getShouldDisplayGlobalLoader = createSelector(
  globalLoaderSelector,
  ({ shouldDisplay }) => shouldDisplay,
);
const getGlobalLoaderLabel = createSelector(globalLoaderSelector, ({ label }) => label);

const getIsNavigation = createSelector(globalLoaderSelector, ({ isNavigation }) => isNavigation);

export { getShouldDisplayGlobalLoader, getGlobalLoaderLabel, getIsNavigation };
